export default function TheBeaconPhilosophy() {
  return <section data-section-id="223297" id="the-beacon-philosophy" className="bg-background text-foreground py-24 md:py-32 lg:py-48 flex items-center justify-center min-h-screen selection:bg-primary/30 selection:text-primary-foreground">
      <div className="w-full px-6 md:w-3/5 mx-auto flex flex-col items-center text-center space-y-12 md:space-y-16">
        {}
        <span className="text-8xl md:text-9xl text-primary leading-none font-default block -mb-12 md:-mb-16 select-none opacity-20" aria-hidden="true">
          &ldquo;
        </span>

        {}
        <p className="text-2xl md:text-3xl lg:text-4xl font-default font-semibold leading-relaxed md:leading-loose text-foreground tracking-tight">
          Transparency is our North Star. We believe that securing a mortgage 
          shouldn&apos;t be a journey through the dark, but a guided path toward 
          financial clarity. At Beacon Finance Group, we don&apos;t just process 
          loans; we architect futures, ensuring every client feels the security 
          and stability of a home built on a foundation of trust and precision.
        </p>

        {}
        <div className="pt-8 md:pt-12 flex flex-col items-center gap-4">
          <span className="text-4xl md:text-5xl font-default font-bold text-primary block tracking-tighter">
            Marcus Sterling
          </span>
          <div className="h-px w-12 bg-primary/20 rounded-md" />
          <span className="text-xs md:text-sm text-primary/70 uppercase tracking-[0.3em] font-mono font-medium">
            Managing Director & Founder
          </span>
        </div>
      </div>
    </section>;
}